// extracted by mini-css-extract-plugin
export default {"sbah":"azkar_sbah__l2VIC","leftAzkar":"azkar_leftAzkar__rKv0Y","clickAzkar":"azkar_clickAzkar__zEFJt"};